module.exports = __webpack_public_path__ + "bfa68a5bb3d230a74cfb0c3a82a7e186.MP3";